import { useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { listingAliasSelector } from '../selectors';

export default function useQueryVariables() {
  const selectorListingAlias = useSelector(listingAliasSelector);
  const { applicantId, applicationId, zgAuthZone } = useParams();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const listingAlias = searchParams.get('propertyId');
  return {
    propertyId: selectorListingAlias ? selectorListingAlias : listingAlias,
    applicationId,
    applicantId,
    zgAuthZone,
  };
}
